import React from "react";
import { TouchableOpacity, StyleSheet } from "react-native";
import { theme } from "../theme/theme";
import Icon from "./Icon";
import { FAB_SIZE, fabShell } from "../styles/appStyles";

/**
 * Circular orange FAB with centred white plus — avoids Paper FAB customSize
 * squircle + missing icon issues on web.
 */
const AppFab = ({
  style,
  onPress,
  accessibilityLabel,
  accessibilityHint,
  testID,
}) => (
  <TouchableOpacity
    testID={testID}
    style={[styles.fab, fabShell, style]}
    onPress={onPress}
    activeOpacity={0.85}
    accessible
    accessibilityRole="button"
    accessibilityLabel={accessibilityLabel}
    accessibilityHint={accessibilityHint}
  >
    <Icon
      name="plus"
      size={Math.round(FAB_SIZE * 0.43)}
      color={theme.colors.onPrimary}
    />
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  fab: {
    width: FAB_SIZE,
    height: FAB_SIZE,
    borderRadius: FAB_SIZE / 2,
    alignItems: "center",
    justifyContent: "center",
  },
});

export default AppFab;
